import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

type IDashboardweeklyprefSlice = {recommendation?:string}

export const DashboardweeklyprefSlice = createSlice({
  name: "DashboardweeklyprefSlice",
  initialState: {} as IReduxState<IDashboardweeklyprefSlice>,
  reducers: {
    dashboardweeklypref: (state) => {
      state.isLoading = true;
    },
    successDashboardweeklypref: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureDashboardweeklypref: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDashboardweeklypref: (state) => {
      state.data = {};
    },
  },
});

export const {
  failureDashboardweeklypref,
  successDashboardweeklypref,
  clearDashboardweeklypref,
  dashboardweeklypref,
} = DashboardweeklyprefSlice.actions;

export default DashboardweeklyprefSlice.reducer;
